import { Tables } from "../../database.types";

export type BlockTypes = "text" | "radio" | "checkbox" | "file";
export type Block = Omit<Tables<"question">, "id" | "created_at" | "form_id">;

export const emptyBlock: Record<BlockTypes, Block> = {
  text: {
    message: "",
    optional: true,
    options: [],
    type: "text",
  },
  radio: {
    message: "",
    optional: true,
    options: [""],
    type: "radio",
  },
  checkbox: {
    message: "",
    optional: true,
    options: [""],
    type: "checkbox",
  },
  file: {
    message: "",
    optional: true,
    options: [""],
    type: "file",
  },
};

export const defaultAgentImage =
  "https://qdltyctfafwvkilhjeln.supabase.co/storage/v1/object/public/website-assets/logo/logo_rounded_symbol_dark.svg";
